import React from 'react';
import { type Weekday } from '@/features/plants/schemas/schedule-plant.schema.ts';
import {
  SCHEDULE_DAY_ROW_HEIGHT_PX,
  SCHEDULE_HOUR_COLUMN_WIDTH_PX,
} from '@/features/plants/components/plant-schedule/schedule/constants.ts';

export function ScheduleHoursGrid({
  days,
  hours,
  onHoursRef,
  onHoursClick,
  hourColumnWidthPx = SCHEDULE_HOUR_COLUMN_WIDTH_PX,
}: {
  days: readonly Weekday[];
  hours: string[];
  onHoursRef: (day: Weekday, el: HTMLDivElement | null) => void;
  onHoursClick: (day: Weekday, e: React.MouseEvent) => void;
  hourColumnWidthPx?: number;
}) {
  return (
    <div className="overflow-hidden rounded-tr-lg rounded-br-lg border-t border-r border-b border-gray-100">
      {days.map((day) => (
        <div key={day} className="border-b border-gray-100 last:border-b-white">
          <div
            className="flex"
            ref={(el) => onHoursRef(day, el)}
            onClick={(e) => onHoursClick(day, e)}
          >
            {hours.map((hour) => (
              <div
                key={`${day}-${hour}`}
                className="relative flex-shrink-0 border-r border-gray-100 bg-white transition-colors last:border-r-0 hover:bg-gray-50"
                style={{
                  width: hourColumnWidthPx,
                  height: SCHEDULE_DAY_ROW_HEIGHT_PX - 1,
                }}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
